import React from 'react';
import { Editor } from '@tiptap/react';
import { useCurrentEditor } from '@tiptap/react';

('use client');

export function useRichTextTiptapEditor(
  providedEditor?: Editor | null,
): Editor | null {
  const { editor: coreEditor } = useCurrentEditor();
  return React.useMemo(
    () => providedEditor || coreEditor,
    [providedEditor, coreEditor],
  );
}
